import React, { useEffect } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { ArrowRight, MapPin, Phone } from 'lucide-react';
import { serviceAreas, business } from '../mock';
import useReveal from '../hooks/useReveal';

export default function ServiceAreas() {
  const { openSchedule } = useOutletContext();
  useReveal();
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  return (
    <>
      <section style={{ paddingTop: 74, backgroundColor: 'var(--cream-2)' }}>
        <div className="container-x py-16 lg:py-20 text-center">
          <p className="eyebrow mb-2">Service Areas</p>
          <h1 style={{ fontSize: 'clamp(2.2rem, 4.6vw, 3.6rem)' }}>In-home senior care across Dallas &amp; Fort Worth</h1>
          <p className="mt-5 text-lg max-w-[680px] mx-auto" style={{ color: 'var(--muted)' }}>
            Since {business.since}, families throughout the DFW metroplex have trusted us to care for
            their loved ones at home. Find dependable Senior Home Care in your community.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <button className="btn-sage" onClick={openSchedule}>Schedule a Consultation <ArrowRight size={18} /></button>
            <a href={business.phoneHref} className="btn-outline"><Phone size={18} /> {business.phone}</a>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-x">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceAreas.map((a) => (
              <Link
                key={a.slug}
                to={`/service-areas/${a.slug}`}
                className="reveal group bg-white rounded-[26px] overflow-hidden transition-all duration-300 hover:-translate-y-1.5"
                style={{ border: '1px solid var(--line)', boxShadow: '0 18px 40px -32px rgba(30,59,44,0.5)' }}
              >
                <div className="relative" style={{ aspectRatio: '16/10' }}>
                  <img src={a.image} alt={`Senior home care in ${a.city}, TX`} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(20,42,31,0) 45%, rgba(20,42,31,0.75) 100%)' }} />
                  <div className="absolute bottom-4 left-5 flex items-center gap-2 text-white">
                    <MapPin size={18} style={{ color: 'var(--sage)' }} />
                    <span className="font-serif-display text-2xl" style={{ color: '#fff' }}>{a.city}</span>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-[15px]" style={{ color: 'var(--muted)' }}>{a.blurb}</p>
                  <span className="inline-flex items-center gap-1.5 mt-4 font-semibold text-[15px]" style={{ color: 'var(--forest)' }}>
                    View {a.city} care <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
